import React from 'react'

import '../App.css'
import '../styles/main.scss'
import '../styles/neighborhood.scss'
import '../styles/mapkey.scss'
import '../styles/index.scss'

export default function DataTag(props){
    return(
    <div className="data-item"> 
        <div>
            <h3 className="text-light">{props.heading1}</h3>
            <h2 className="text-bold">{props.content1}</h2>
        </div>
        <div>
            <h3 className="text-light">{props.heading2}</h3>
            <h2 className="text-bold">{props.content2}</h2>
        </div>
    </div>
    )
}